export default __webpack_public_path__ + "static/media/karada-arrange-recovery-lactic-acid-bacteria-powder-temporary.5394d19b.png";